module.exports = __webpack_public_path__ + "static/media/lease-truck-program-grid-1.3303f95d.jpeg";